import { observable, computed } from 'mobx';
import { Model, App, ArrayApp, ModelRegistry, AppRegistry } from 'core';
import { parseISO, addBusinessDays } from 'date-fns';
import { graphqlIdToDecimal } from 'utils/dgraphId';

class OrderConfirmationModel extends Model {
  static registryName = 'OrderConfirmationModel';

  @observable id;
  @observable customer = '';
  @observable timestamp = '';
}

export class PaymentModel extends Model {
  static registryName = 'PaymentModel';

  // Not using Models for Card and BillingAddress as they come from stripe and don't have an id
  // static ModelProps = {
  // card: CardModel,
  // billingAddress: BillingAddress,
  // };

  @observable id;
  @observable for;
  @observable tax;
  @observable amount = '';
  @observable currency;
  @observable receiptUrl;
  @observable createdAt;

  @observable card = {};
  @observable billingAddress = {};

  @computed get displayCurrency() {
    if (this.currency === 'eur') return '€';
    if (this.currency === 'usd') return '$';
    return '';
  }
}

export class OrderModel extends Model {
  static registryName = 'OrderModel';

  static ModelProps = {
    quote: 'ShipmentQuoteModel',
    confirmation: OrderConfirmationModel,
    payments: [PaymentModel],
  };

  @observable id;
  @observable createdAt;
  @observable paymentStatus;
  @observable orderStatus;
  @observable shippingDetail;
  @observable nextPossibleStatuses = [];

  @observable quote = null;
  @observable confirmation = null;
  @observable payments = [];

  @computed get decimalId() {
    return graphqlIdToDecimal(this.id);
  }

  @computed get deliveryDate() {
    const startingDate = parseISO(this.createdAt);
    const manuPlusShippingTime =
      this.quote.manufacturingTime +
      this.quote.shippingQuote.deliveryTime +
      this.quote.bufferTime;
    return addBusinessDays(startingDate, manuPlusShippingTime);
  }
}
ModelRegistry.add(OrderModel);

export class OrderApp extends App {
  static registryName = 'OrderApp';
  static Model = OrderModel;

  static AppProps = {
    quote: 'ShipmentQuoteApp',
    // confirmation: 'OrderConfirmationApp',
    // payments: 'PaymentArrayApp',
  };

  @computed get decimalId() {
    return graphqlIdToDecimal(this.id);
  }

  @computed get deliveryDate() {
    const startingDate = parseISO(this.createdAt);
    const manuPlusShippingTime =
      this.quote.manufacturingTime +
      this.quote.shippingQuote.deliveryTime +
      this.quote.bufferTime;
    return addBusinessDays(startingDate, manuPlusShippingTime);
  }
}
AppRegistry.add(OrderApp);

export class OrdersArrayApp extends ArrayApp {
  static registryName = 'OrdersArrayApp';

  static ElementApp = OrderApp;
}
AppRegistry.add(OrdersArrayApp);
